export class Cupon{
    constructor(
        public _id: string,
        public categoria: string,
        public descuento: number,
        public codigo: string,
    ){
    }
}
